// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inline {
  background: none;
}
.blocked {
  background: #505050d9;
  color: white;
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 18px;
  position: fixed !important;
}
.loader-container {
  z-index: 999999;
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 10px;
  transform: translate(-50%, -50%);
}
.loader-spinner {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/base-components.ts"],"names":[],"mappings":";AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["\n.inline {\n  background: none;\n}\n.blocked {\n  background: #505050d9;\n  color: white;\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-size: 18px;\n  position: fixed !important;\n}\n.loader-container {\n  z-index: 999999;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  padding: 10px;\n  transform: translate(-50%, -50%);\n}\n.loader-spinner {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
